export const CRM_OBJECT_TYPE_IDS = {
  CONTACT: '0-1',
  COMPANY: '0-2',
  CONTACT_LIST: '0-45',
  WEB_VISITOR_SEGMENT: '0-820'
};
export const AUDIENCE_CRM_OBJECT_TYPES = {
  [CRM_OBJECT_TYPE_IDS.CONTACT]: 'contact',
  [CRM_OBJECT_TYPE_IDS.COMPANY]: 'company',
  [CRM_OBJECT_TYPE_IDS.CONTACT_LIST]: 'contactList',
  [CRM_OBJECT_TYPE_IDS.WEB_VISITOR_SEGMENT]: 'webVisitorSegment'
};